// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @ actions
const agentAuthentication = require('actions/contactCenter/agentAuthentication/agentAuthentication');
const customerFinderActions = require('actions/contactCenter/customerFinder');
const disasterRecoveryAgentTokenRenewalActions = require('actions/contactCenter/disasterRecoveryAgentTokenRenewal/disasterRecoveryAgentTokenRenewal');
const stepClientLoginActions = require('actions/contactCenter/customerFinderSteps/stepClientLogin');
const stepSearchClientActions = require('actions/contactCenter/customerFinderSteps/stepSearchClient');
const stepValidateInteractionIdActions = require('actions/contactCenter/customerFinderSteps/stepValidateInteractionId');
const translations = require('actions/translations');
// @ components
const CustomerFinderView = require('components/contactCenter/disasterRecovery/customerFinderView/customerFinderView');

class CustomerFinderViewContainer extends React.Component {
    render() {
        const { confirmLogin, history } = this.props;
        const confirmLoginFunction = (interactionId, dropdownOption, positions, values) => confirmLogin(interactionId, dropdownOption, positions, values, history);

        return (
            <CustomerFinderView {...this.props} confirmLogin={confirmLoginFunction} />
        );
    }
}

CustomerFinderViewContainer.propTypes = {
    changeOfficeValidation: PropTypes.func.isRequired,
    clearInteractionIdErrorMessage: PropTypes.func.isRequired,
    clearRequest: PropTypes.func.isRequired,
    confirmClientSearch: PropTypes.func.isRequired,
    confirmLogin: PropTypes.func.isRequired,
    endInteraction: PropTypes.func.isRequired,
    immAgentLogin: PropTypes.object.isRequired,
    immCustomerFinder: PropTypes.object.isRequired,
    immDisasterRecoveryAgentTokenRenewal: PropTypes.object.isRequired,
    immTranslations: PropTypes.object.isRequired,
    resetErrorMessage: PropTypes.func.isRequired,
    showEmptyDocumentError: PropTypes.func.isRequired,
    startAgentTokenRenewalTimer: PropTypes.func.isRequired,
    updateInteractionId: PropTypes.func.isRequired,
    validateInteractionId: PropTypes.func.isRequired,
    validateInteractionIdWithAPI: PropTypes.func.isRequired,
    requestTranslations: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
}

module.exports.constructor = CustomerFinderViewContainer;
module.exports.CustomerFinderViewContainer = withRouter(connect(
    state => ({
        immAgentLogin: state.agentAuthentication,
        immCustomerFinder: state.customerFinder,
        immDisasterRecoveryAgentTokenRenewal: state.disasterRecoveryAgentTokenRenewal,
        immTranslations: state.translations,
        immLogin: state.okLogin
    }),
    {
        changeOfficeValidation: agentAuthentication.agentOfficeValidation,
        clearInteractionIdErrorMessage: stepValidateInteractionIdActions.clearInteractionIdErrorMessage,
        clearRequest: customerFinderActions.clearRequest,
        confirmClientSearch: stepSearchClientActions.confirmClientSearch,
        confirmLogin: stepClientLoginActions.confirmLogin,
        endInteraction: customerFinderActions.endInteraction,
        resetErrorMessage: stepSearchClientActions.resetErrorMessage,
        showEmptyDocumentError: stepSearchClientActions.showEmptyDocumentError,
        startAgentTokenRenewalTimer: disasterRecoveryAgentTokenRenewalActions.startAgentTokenRenewalTimer,
        updateInteractionId: stepValidateInteractionIdActions.updateInteractionId,
        validateInteractionId: stepValidateInteractionIdActions.validateInteractionId,
        validateInteractionIdWithAPI: stepValidateInteractionIdActions.validateInteractionIdWithAPI,
        requestTranslations: translations.requestTranslations
    }
)(CustomerFinderViewContainer));
